import React from 'react';
import './about.css';
import About from '../images/aboutColoured.png';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';

const about = () => {
    return (
      <div>
      <div>
        <Helmet>
          <title>Team | ENT Chatbot</title>
        </Helmet>
      </div>
      <div class = "about-container">
        <div class = "about-image">
          <img src={About} width = '75px'/>
        </div>
        <div class = "about-text">
          <h1 id="team-text"> Team </h1>
          <h1 class = "subheading-text-about"> Learn about the team behind this project </h1>
          <div class = "line-about">
            <hr></hr>
          </div>
          <h1 class = "heading-text-about"> Our Goal </h1>
          <h1 class = "body-text-about"> Our goal is to improve upon the current process of obtaining information about ENT surgeries. Informed consent is a vital aspect of
             allowing patients to make decisions about their health. By allowing patients to have access to accurate but simple information, we can prevent patients from being
             overwhelmed with information that may not apply to their situation. Thus, paitents will feel safe, confident and informed regarding their ENT surgery.</h1>
          <h1 class = "heading-text-about"> Who We Are </h1>
          <h2 class = "body-text-about"> We are a team of fourth year Computer Science students at McMaster Unversity. We are supervised by a medical team consisting of Dr. Benjamin
             Van der Woerd and Lomesh Choudhary to ensure medical accuracy. Additionally, we have supervisors Dr. Denise Geiskkovitch and Dr. Charles Welch overseeing development 
             and progress.</h2>
          <div class = "line-about">
            <hr></hr>
          </div>
          <h1 class = "heading-text-about"> Medical Team </h1>
          <h2 class = "name-text-about"> Dr. Benjamin Van der Woerd </h2>
          <h2 class = "subbody-text-about"> Laryngologist at McMaster University, St. Joseph's Healthcare Hamilton </h2>
          <h2 class = "name-text-about"> Lomesh Choudhary </h2>
          <h2 class = "subbody-text-about"> PhD Student at McMaster University </h2>

          <h1 class = "heading-text-about"> Supervisors </h1>
          <h2 class = "name-text-about"> Dr. Charles Welch </h2>
          <h2 class = "subbody-text-about"> Assistant Professor at McMaster University</h2>
          <h2 class = "name-text-about"> Dr. Denise Geiskkovitch </h2>
          <h2 class = "subbody-text-about"> Assistant Professor at McMaster University, Barber-Gennum Endowed Chair in Information Technology</h2>
          <h2 class = "name-text-about"> Dr. Mehdi Moradi </h2>
          <h2 class = "subbody-text-about"> Associate Professor at McMaster University</h2>

          <h1 class = "heading-text-about"> Developers </h1>
          <h2 class = "name-text-about"> Ben Weeks </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
          <h2 class = "name-text-about"> Corinna Lin </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
          <h2 class = "name-text-about"> Deluckshan Murugesu </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
          <h2 class = "name-text-about"> Donyasadat Zolfaghari </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
          <h2 class = "name-text-about"> Javier Afonso </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
          <h2 class = "name-text-about"> Kieran Henderson  </h2>
          <h2 class = "subbody-text-about"> Fourth Year Computer Science Student at McMaster University</h2>
        </div>
        </div>
        <Footer/>

      </div>
    );
  };
  
export default about;